import { render, staticRenderFns } from "./systemConfig.vue?vue&type=template&id=2809d89e&scoped=true&"
import script from "./systemConfig.vue?vue&type=script&lang=js&"
export * from "./systemConfig.vue?vue&type=script&lang=js&"
import style0 from "./systemConfig.vue?vue&type=style&index=0&id=2809d89e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2809d89e",
  null
  
)

export default component.exports